import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "./SessionContext";

// TODO: only the lender dashboard exists today, so a logged-in visitor with
// nowhere specific to go back to defaults here. Once a borrower dashboard
// and user-type/role data exist, pick the destination based on user type
// instead of hardcoding this path.
const DEFAULT_POST_LOGIN_ROUTE = "/dashboard";

// Wraps /auth — the single place that decides where a logged-in user at
// /auth actually goes, covering both cases with one code path: a stale
// bookmark/back-button visit (no `from` state -> the dashboard) and the
// moment right after AuthPage's login/signup/reset flow calls
// useSession().login() (state.isAuthenticated flips true while still
// rendering at /auth -> straight back to whatever RequireAuth redirected the
// user away from). AuthPage deliberately does NOT also call navigate() after
// login — doing so raced this component's own effect-driven redirect and
// the wrong one won, always landing on the dashboard instead of the
// originally requested page.
export function RedirectIfAuthenticated() {
  const { isAuthenticated } = useSession();
  const location = useLocation();

  if (isAuthenticated) {
    const state = location.state as { from?: { pathname?: string } } | null;
    return <Navigate to={state?.from?.pathname ?? DEFAULT_POST_LOGIN_ROUTE} replace />;
  }

  return <Outlet />;
}
